var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"primary-button button",class:{
    disabled: _vm.disabled,
    blue: _vm.blue,
    green: _vm.green,
    grey: _vm.grey,
    white: _vm.white,
    atlantis: _vm.atlantis,
    independence: _vm.independence,
    pizazz: _vm.pizazz,
    'rounded-corner': _vm.roundedCorner,
    'pure-icon': _vm.pureIcon
  },attrs:{"type":_vm.type,"title":_vm.pureIcon ? _vm.text : ''},on:{"click":_vm.onclick,"mouseover":_vm.onmouseover}},[(_vm.hasIcon)?_vm._t("icon"):_vm._e(),(!_vm.pureIcon)?_c('span',[_vm._v(_vm._s(_vm.text))]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }